function restoreLibraryStateFromSearchParams(state, location) {
  if (!location) {
    return state;
  }
  const restoredState = structuredClone(state);
  const displayMode = (() => {
    const base = location.searchParams.get("view");
    if (base !== "list" && base !== "grid") {
      return undefined;
    }
    return base;
  })();
  const itemId = location.searchParams.get("item") ?? undefined;
  const groupIds = location.searchParams.get("group") ?? undefined;
  const query = location.searchParams.get("query") ?? undefined;
  const filters = (() => {
    try {
      return JSON.parse(location.searchParams.get("filters") ?? "null");
    } catch {
      return undefined;
    }
  })();
  if (displayMode) {
    restoredState.ui.displayMode = displayMode;
  }
  if (itemId) {
    restoredState.ui.expandedItemId = itemId;
  }
  if (groupIds) {
    const parsedIds = Object.fromEntries(groupIds.split(",").map(id => [id, true]));
    restoredState.ui.selectedGroupIds = parsedIds;
  }
  if (query) {
    restoredState.filters.searchQuery = query;
  }
  if (filters?.accordions) {
    restoredState.filters.selected.accordions = filters.accordions;
  }
  if (filters?.checkboxes) {
    restoredState.filters.selected.checkboxes = filters.checkboxes;
  }
  if (filters?.radiobuttons) {
    restoredState.filters.selected.radiobuttons = filters.radiobuttons;
  }
  return restoredState;
}

export { restoreLibraryStateFromSearchParams };
//# sourceMappingURL=util.restore-state-from-search-params.js.map
